import './index.css'
import {useRouteError} from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError() as ({ statusText?: string, message?: string });
    console.error(error);

    return (
        <div className="error-page flex-box-centered flex-direction-column">
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
        </div>
    );
}
